import { InteractionBar } from "@/components/molecules/interactionWorkspace";
import { InteractionType } from "@/common/types";
import {
	CurrentInteractionState,
	useCurrentInteractionStore,
} from "@/common/stores/nonpersistingStores/currentInteraction";
import { VoicemailContent } from "@/components/molecules/voicemail/VoicemailContent";
import { useMemo } from "react";

export const VoicemailInteractionPanel = () => {
	const currentInteraction = useCurrentInteractionStore(
		(state: CurrentInteractionState) => state.active
	);

	const voicemailOverview = useMemo(() => {
		if (currentInteraction) {
			const voicemailOverview = (({
				id,
				voicemailIsTranscriptionProcessed,
				description,
				voicemailExpireDate,
				voicemailFilePath,
			}) => ({
				id,
				transcription: description,
				expireDate: voicemailExpireDate,
				filePath: voicemailFilePath,
				isTranscriptionProcessed: voicemailIsTranscriptionProcessed || false,
			}))(currentInteraction);

			return voicemailOverview;
		} else {
			return undefined;
		}
	}, [currentInteraction]);

	return (
		<>
			<InteractionBar type={InteractionType.Voicemail} />
			<>
				{voicemailOverview && (
					<VoicemailContent voicemailOverview={voicemailOverview} />
				)}
			</>
		</>
	);
};
